/**
 * No.205: label of a karte in the カルテ tab.
 * A prescription karte created automatically for an LP direct purchase
 * (is_auto_prescription) is shown as 「自動処方」.
 */
export interface KarteTypeSource {
  type?: string | null;
  is_auto_prescription?: boolean | null;
}

export interface KarteBadge {
  label: string;
  className: string;
}

export const KARTE_AUTO_PRESCRIPTION_LABEL = '自動処方';

export const isAutoPrescriptionKarte = (feedback: KarteTypeSource | null | undefined): boolean =>
  !!feedback && feedback.type !== 'memo' && feedback.is_auto_prescription === true;

export const getKarteBadge = (feedback: KarteTypeSource | null | undefined): KarteBadge => {
  if (feedback?.type === 'memo') {
    return { label: 'メモ', className: 'karte-type-memo' };
  }
  if (isAutoPrescriptionKarte(feedback)) {
    return { label: KARTE_AUTO_PRESCRIPTION_LABEL, className: 'karte-type-auto' };
  }
  return { label: '処方', className: 'karte-type-prescription' };
};
